import { useState, useEffect } from 'react'

const iPad = navigator.platform == 'MacIntel' && navigator.maxTouchPoints > 1

const useFullscreen = () => {
  const [ fullscreen, setFullscreen ] = useState(!!document.fullscreenElement)

  const toggleFullscreen = () => {
    if (fullscreen)
      document.exitFullscreen()
    else
      document.documentElement.requestFullscreen({ navigationUI: 'hide' })
  }

  useEffect(() => {
    const handleChange = () => setFullscreen(!!document.fullscreenElement)
    document.addEventListener('fullscreenchange', handleChange)
    return () => document.removeEventListener('fullscreenchange', handleChange)
  }, [])

  const iPadFullscreen = iPad && fullscreen

  return { fullscreen, toggleFullscreen, iPadFullscreen }
}

export default useFullscreen
